import { Environment } from '@sitecore-ui/portal-singular';
import { env } from 'features/common/config/envConfig';
import {
  IAuthUnifiedTrackingRequest,
  IConfigUnifiedTrackingRequest,
  IUnifiedTrackingRequest,
} from './unifiedTrackingModel';

export const getUnifiedTrackingApiBaseUrl = (region?: string) => {
  let url = '';

  switch (env) {
    case Environment.dev:
    case Environment.qa:
    case Environment.staging:
      url = 'wss://unifiedtracking-dev-euw.sitecore-staging.cloud';
      break;

    case Environment['pre-production']:
    case 'preprod':
      url = '';
      break;

    case Environment.production:
    case 'prod':
    default:
      if (region?.includes('us-')) {
        url = 'wss://unifiedtracking-use.sitecorecloud.io';
      } else if (region?.includes('au-')) {
        url = 'wss://unifiedtracking-aue.sitecorecloud.io';
      } else if (region?.includes('jp-')) {
        url = 'wss://unifiedtracking-jpe.sitecorecloud.io';
      } else {
        url = 'wss://unifiedtracking-euw.sitecorecloud.io';
      }
      break;
  }

  return url;
};

export const sedDataWs = async function (
  ws: WebSocket | undefined,
  data: IUnifiedTrackingRequest<any>,
) {
  if (ws?.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify(data));
  }
};

export const wsAuthorizeMsg = (
  organizationId: string,
  token: string,
  uuid: string,
) => {
  const authReq: IUnifiedTrackingRequest<IAuthUnifiedTrackingRequest> = {
    id: `request-auth-${uuid}`,
    orgId: organizationId,
    route: 'authorize',
    data: {
      token: `${token}`,
    },
  };

  return authReq;
};
export const wsAuthorize = (
  ws: WebSocket | undefined,
  organizationId: string,
  token: string,
  uuid: string,
) => {
  try {
    const authReq = wsAuthorizeMsg(organizationId, token, uuid);

    return sedDataWs(ws, authReq);
  } catch (error) {
    console.error('Error:' + error);
  }
};

export const wsTenantConfigMsg = (
  organizationId: string,
  tenantId: string,
  uuid: string,
) => {
  const baseConfigReq: IUnifiedTrackingRequest<IConfigUnifiedTrackingRequest> =
    {
      id: `request-config-tenant-${uuid}`,
      orgId: organizationId,
      route: 'configuration',
      data: {
        tenantId: tenantId,
      },
    };

  return baseConfigReq;
};

export const wsTenantConfig = (
  ws: WebSocket | undefined,
  organizationId: string,
  tenantId: string,
  uuid: string,
) => {
  try {
    const baseConfigReq = wsTenantConfigMsg(organizationId, tenantId, uuid);

    return sedDataWs(ws, baseConfigReq);
  } catch (error) {
    console.error('Error:' + error);
  }
};

export const wsOrgConfigMsg = (organizationId: string, uuid: string) => {
  const organizationReq: IUnifiedTrackingRequest<any> = {
    id: `request-organization-base-${uuid}`,
    orgId: organizationId,
    route: 'organization',
    data: {},
  };

  return organizationReq;
};
export const wsOrgConfig = (
  ws: WebSocket | undefined,
  organizationId: string,
  uuid: string,
) => {
  try {
    const organizationReq = wsOrgConfigMsg(organizationId, uuid);

    return sedDataWs(ws, organizationReq);
  } catch (error) {
    console.error('Error:' + error);
  }
};
